
/* injects from baggage-loader */

'use strict';

const FINISH_TIMEOUT = 600;
const TRANSITION_TIMEOUT = 400;

export default class BalloonsController {
	constructor($log, $timeout) {
		'ngInject';
		this.$log = $log;
		this.$timeout = $timeout;
		this.dialogPosition = 0;
	}

	$onInit() {
		this.$log.debug(this);
	}

	toggle(){
		this.isVisible ? this.hide() : this.show();
	}

	show(){
		this.isVisible = true;
		this.$timeout(angular.bind(this, this.reset), TRANSITION_TIMEOUT);
	}

	hide(){
		this.isVisible = false;
		this.$timeout(angular.bind(this, this.reset), TRANSITION_TIMEOUT);
	}
  
	finish(){
		this.hide();
		this.$timeout(angular.bind(this, this.onFinish), FINISH_TIMEOUT);
	}

	next(){
		if (this.dialogPosition < ( this.data.length - 1 )){
			this.dialogPosition++;
		}
	}

	before(){
		if (this.dialogPosition > 0){
			this.dialogPosition--;
		}
	}

	reset(){
		this.dialogPosition = 0;
	}
}


// WEBPACK FOOTER //
// ./src/app/components/balloons/balloons.controller.js